// The operator's choice when a verdict names a product that differs from what
// the worker wrote (Prism spec kg_quote_path ruling 9). Recording the verdict
// alone labels both systems in the graph and leaves the item and its prices as
// they are; recording AND updating the item edits brand and model through the
// same path as a hand edit, which clears the item's prices and asks for a
// reprice. Cosmetic differences (a dash, spacing, case) never reach this
// dialog: identityAgreement.verdictChangesWorkerIdentity ignores them.
export default function VerdictApplyDialog({ workerText, productName, onCancel, onRecordOnly, onRecordAndUpdate }) {
    return (
        <div className="modal-overlay">
            <div className="modal-content" onClick={e => e.stopPropagation()} data-testid="verdict-apply-dialog">
                <div className="modal-header">
                    <h2>Record verdict</h2>
                    <button className="modal-close" onClick={onCancel}>&times;</button>
                </div>
                <div className="modal-body-scroll">
                    <p>
                        Worker wrote <strong>{workerText || '(nothing)'}</strong>. You are recording <strong>{productName}</strong>.
                    </p>
                    <p className="qa-muted">
                        Recording only labels the KG answer and keeps the item&apos;s brand, model and prices as they
                        are. Updating the item as well writes the brand and model onto it, which clears its prices,
                        and then asks for a reprice.
                    </p>
                </div>
                <div className="modal-footer" style={{ padding: 'var(--space-4)' }}>
                    <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
                    <button className="btn" onClick={onRecordOnly}>Record verdict only</button>
                    <button className="btn btn-accent" onClick={onRecordAndUpdate}>Record and update item</button>
                </div>
            </div>
        </div>
    );
}
